import {IDotRezSessionTimerModel} from "./dot-rez-session-timer.interface";
import {TryRefreshTokenResultEnum} from "./try-refresh-token-result.enum";

export class DotRezTransientSessionTimer implements IDotRezSessionTimerModel {

    constructor(public token: string) {
    }
    dispose(): void {
    }


    get tokenExpirationDate(): Date {
        return new Date(Date.now() + 60 * 60 * 1000);
    }

    async setExpired(): Promise<void> {
    }

    isExpired(): Promise<boolean> {
        return Promise.resolve(false);
    }

    pause(): void {

    }
    resume(): Promise<void> {
        return Promise.resolve();
    }

    async tryRefreshToken(): Promise<TryRefreshTokenResultEnum> {
        return TryRefreshTokenResultEnum.Success;
    }

    updateToken(token: string, tokenExpirationDate: Date): void {
        this.token = token;
    }
}
